export const convertQueryParam = (params: Record<string, any> | undefined): string => {
  if (!params || Object.keys(params).length === 0) {
    return '';
  }

  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    if (Array.isArray(value)) {
      searchParams.set(key, value.join(','));
    } else {
      searchParams.set(key, String(value));
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

export const getImage = (url: string) => {
  const base = 'https://medilawyer-images.s3.ap-northeast-2.amazonaws.com';
  return base + url;
};
